export const GET_AGENCIES_BY_COUNTRY = 'app/Managers/GET_AGENCIES_BY_COUNTRY';
export const GET_AGENCIES_LIST = 'app/Managers/GET_AGENCIES_LIST';
export const SET_COUNTRY_INFO = 'app/Managers/GET_COUNTRY_INFO';
